module.exports = __webpack_public_path__ + "media/recipes/131-d2b31709.png";